import { render, staticRenderFns } from "./insider.vue?vue&type=template&id=58885a9b&"
import script from "./insider.vue?vue&type=script&lang=js&"
export * from "./insider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports